export class BaseLoginError {

    constructor(isShow : boolean) {
        this.isShow = isShow;
    }
    isShow : boolean = false;
}